export default {
  sliders: [],

  blogs: [],

  medias: [],

  sounds: [],

  photos: [],

  books: [],
};
